import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import SelectAutoComplete from "../../../ui/selectAutoComplete/SelectAutoComplete";
import { useState, useEffect } from "react";
import { getTiposCargos } from "../../../components/functions/Soporte";

const NuevoContactoCFE = ({
  open,
  onClose,
  onConfirm,
  API_URL,
  contacto = null,
}) => {
  const [tiposCargos, setTiposCargos] = useState([]);
  const [contactoForm, setContactoForm] = useState({});

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const tiposCargosRes = await getTiposCargos(API_URL);

      setTiposCargos(tiposCargosRes);
    };

    if (open) {
      fetchData();
    }
    if (contacto) {
      setContactoForm(contacto);
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setContactoForm({});
    setTiposCargos([]);
  };

  const handleConfirm = async () => {
    if (!contactoForm?.nombre || !contactoForm?.tipoCargo) {
      setSnackbarMessage("Por favor, complete los campos obligatorios.");
      setShowSnackbar(true);
      return;
    }
    onConfirm(contactoForm);
    handleClose();
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>
        {contacto ? "Editar" : "Registrar"} Contacto CFE
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
          }}
        >
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Nombre:</label>
            <input
              className="form-input"
              placeholder="Nombre..."
              value={contactoForm?.nombre || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  nombre: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Apellido:</label>
            <input
              className="form-input"
              placeholder="Apellido..."
              value={contactoForm?.apellidos || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  apellidos: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">E-mail:</label>
            <input
              className="form-input"
              placeholder="E-mail..."
              value={contactoForm?.email || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  email: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="form-label">Posición:</label>
            <SelectAutoComplete
              label=""
              fieldC="descripcion"
              options={tiposCargos}
              value={contactoForm.tipoCargo}
              onChange={(e, value) =>
                setContactoForm((prev) => ({ ...prev, tipoCargo: value }))
              }
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div style={{}}>
            <label className="form-label">Teléfono:</label>
            <input
              className="form-input"
              placeholder="Teléfono..."
              value={contactoForm?.telefono || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  telefono: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{}}>
            <label className="form-label">Ext:</label>
            <input
              className="form-input"
              placeholder="Ext..."
              value={contactoForm?.extension || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  extension: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{}}>
            <label className="form-label">Celular:</label>
            <input
              className="form-input"
              placeholder="Celular..."
              value={contactoForm?.celular || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  celular: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{}}>
            <label className="form-label">Teléfono alternativo:</label>
            <input
              className="form-input"
              placeholder="Teléfono alternativo..."
              value={contactoForm?.telefonoOpcional || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  telefonoOpcional: e.target.value,
                }));
              }}
              style={{ color: "black" }}
            />
          </div>
          <div style={{ gridColumn: "span 4" }}>
            <label className="form-label">Dirección:</label>
            <textarea
              placeholder="Dirección..."
              value={contactoForm?.direccion || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  direccion: e.target.value,
                }));
              }}
              style={{ color: "black" }}
              rows="2"
            />
          </div>
          <div style={{ gridColumn: "span 4" }}>
            <label className="form-label">Comentarios:</label>
            <textarea
              placeholder="Comentarios..."
              value={contactoForm?.comentarios || ""}
              onChange={(e) => {
                setContactoForm((prev) => ({
                  ...prev,
                  comentarios: e.target.value,
                }));
              }}
              style={{ color: "black" }}
              rows="2"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default NuevoContactoCFE;
